/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ContactSetSearch from "./ContactSetSearch";
import ContactSetsList from "./ContactSetsList";
import GroupsIcon from "../../assets/icons/groups.svg2";
import GroupsAddIcon from "../../assets/icons/groups_add.svg2";
import { setCurrentModal } from "../store/slices/modalsSlice";
import AssetsLinks from "../Assets/AssetsLinks";
import Subheading from "../Common/Subheading";
import PageHeader from "../Common/PageHeader";
import { isUserPermitted } from "../helpers/pageProps";
import WhiteButton from "../Common/WhiteButton";
import HelpButton from "../HelpContent/HelpButton";

export default function ContactSets({ contactSetButton, isModal }) {
  const dispatch = useDispatch();
  const setContactSetModalData = (d) => {
    dispatch(
      setCurrentModal({
        modal: "contactSet",
        data: d,
      })
    );
  };
  const [search, setSearch] = useState("");
  const [csType, setCsType] = useState("");
  const [orderBy, setOrderBy] = useState("edited");
  const [refresh, setRefresh] = useState(new Date());

  return (
    <div className="">
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <Subheading
            Icon={GroupsIcon}
            heading="Groups"
            subheading="Control your Groups"
          />
          <div
            title={
              isUserPermitted("edit_group")
                ? "Edit group"
                : "You do not have permission to create groups"
            }
          >
            {isModal ? (
              <WhiteButton
                as="button"
                onClick={() => {
                  setContactSetModalData({
                    uuid: "new",
                    onClose: setRefresh(new Date()),
                  });
                }}
                icon={GroupsAddIcon}
                heading="Create"
                subheading={
                  <>
                    a new group <HelpButton helpKey="add-group" />
                  </>
                }
                disabled={!isUserPermitted("edit_contact")}
                title={
                  isUserPermitted("edit_contact")
                    ? "Add group"
                    : "You do not have permission to add a group"
                }
              />
            ) : (
              <WhiteButton
                as="RRLink"
                to="/assets/contacts/groups/new"
                icon={GroupsAddIcon}
                heading="Create"
                subheading="a new group"
                disabled={!isUserPermitted("edit_contact")}
                title={
                  isUserPermitted("edit_contact")
                    ? "Add group"
                    : "You do not have permission to add a group"
                }
              />
            )}
          </div>
        </div>
      </div>

      <div className="my-3">
        <div className="bg-colored-reverse p-3 rounded-3 d-flex flex-wrap align-items-end mb-3 gap-2">
          <ContactSetSearch
            csType={csType}
            setCsType={setCsType}
            search={search}
            setSearch={setSearch}
            orderBy={orderBy}
            setOrderBy={setOrderBy}
          />
        </div>
      </div>
      <div className="flex-grow-1 position-relative my-2">
        {isUserPermitted("view_group") ? (
          <ContactSetsList
            contactSetButton={contactSetButton}
            search={search}
            csType={csType}
            orderBy={orderBy}
            refresh={refresh}
            isModal={isModal}
          />
        ) : (
          <div className="alert alert-warning">
            You do not have permission to view groups.
          </div>
        )}
      </div>
    </div>
  );
}
